import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import maintananceImg from '../assets/maintanance-img.png';
import logo from '../assets/images/inmate-white-logo.png';
import Button from "../components/common/ui/Button";
import "../css/MaintenancePage.css";
import { kioskLoginActions } from '../_store';
import { useDispatch } from 'react-redux';

const MaintenancePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginInterval = 60000; // 1min once check

  const handleUserAction = () => {
    dispatch(kioskLoginActions.MaintenanceMode("WEB"))
      .then((result) => {
        const data = result?.payload;
        if (
          Object?.keys(data).length === 0 ||
          data?.IsApplicationMaintenance === 1
        )
          return;
        navigate("/"); window.location.reload();
      })
      .catch((err) => {
        console.log("Failed to fetch maintenance data", "error");
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleUserAction();
    }, loginInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  return (
    <div className="parent-container">
      <div>
        <div className="inmate-logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="maintance-content  shadow-sm b-r-all ">
          <div className="">
            <img src={maintananceImg} alt="Logo" className="maintance-logo img" />
          </div>
          <p className='maintance-text' >
            This website is currently undergoing maintenance and will be back
            online shortly. Thank you for your patience.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              className="mt-2"
              onClick={() => { handleUserAction() }}
              label="BACK TO LOGIN"
              type="button"
              status="primary"
            />
          </div>
        </div>
        <div className="maintance-footer">
          <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
